export default __webpack_public_path__ + "assets/e5ddbbd9e00017c4bca0bea402de6efd.svg";